var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessageUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00091 7.8L1.20091 5L0.267578 5.93334L4.00091 9.66667L12.0009 1.66667L11.0676 0.733337L4.00091 7.8Z",
    fill: "#7E808F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageUnread);
export default __webpack_public_path__ + "static/media/iconMessageUnread.278e485febf47bac6d6a0d7062aa634a.svg";
export { ForwardRef as ReactComponent };